import withModal from 'commons-general/components/HOC/withModal.jsx';
import Modal from 'commons-general/components/Modal/Modal.jsx';
import LoginModal from 'commons-general/components/LoginModal/LoginModal.jsx';
import WhiteModal from 'commons-general/components/WhiteModal/WhiteModal.jsx';
import NoSSR from 'commons-general/components/NoSSR/NoSSR.jsx';

import ClickOut from 'commons-general/components/Library/ClickOut/ClickOut.jsx';
import YoutubePlayer from 'commons-general/components/YoutubePlayer/YoutubePlayer.jsx';
import LightBox from 'commons-general/components/LightBox/LightBox.jsx';
import LoaderFullScreen from 'commons-general/components/LoaderFullScreen/LoaderFullScreen.jsx';
import RectangleSkeleton from 'commons-general/components/Skeletons/RectangleSkeleton.jsx';

import TRACKING_TAGS from 'commons-general/constants/trackingTags.js';
import VIRTUAL_PAGEVIEWS from 'commons-general/constants/virtualPageViews.js';
import DATA_LAYER_VARIABLES from 'commons-general/constants/dataLayerVariables.js';
import COOKIES from 'commons-general/constants/cookies.js';
import TIME from 'commons-general/constants/time.js';
import LEAD_TYPES from 'commons-general/constants/leadTypes.js';
import REDIRECTIONS from 'commons-general/constants/redirections.js';
import MEDIA_QUERIES from 'commons-general/constants/mediaQueries.js';
import EVENTS from 'commons-general/constants/events.js';
import MODAL_NAMES from 'commons-general/constants/modalNames.js';

import AnalyticsService from 'commons-general/services/AnalyticsService/AnalyticsService.js';
import CookieService from 'commons-general/services/CookieService/CookieService.js';
import LeadService from 'commons-general/services/LeadService/LeadService.js';
import ShiftDigitalService from 'commons-general/services/ShiftDigitalService/ShiftDigitalService.js';
import LocalStorageService from 'commons-general/services/LocalStorageService/LocalStorageService.js';
import ModalInstance from 'commons-general/services/ModalService/ModalInstance.js';
import ModalService from 'commons-general/services/ModalService/ModalService.js';
import UtilsService from 'commons-general/services/UtilsService/UtilsService.js';
import AccountService from 'commons-general/services/AccountService/AccountService.js';
import ProfileService from 'commons-general/services/ProfileService/ProfileService.js';
import StateService from 'commons-general/services/StateService/StateService.js';
import HistoryService from 'commons-general/services/HistoryService/HistoryService.js';
import SessionStorageService from 'commons-general/services/SessionStorageService/SessionStorageService.js';
import VehiclesService from 'commons-general/services/VehiclesService/VehiclesService.js';

import accountReducer from 'commons-general/reducers/accountReducer.js';
import * as accountActions from 'commons-general/actions/accountActions.js';
import * as accountActionTypes from 'commons-general/actions/accountActionTypes.js';

import Lead from 'commons-general/models/Lead/LeadModel.js';
import TradeInVehicle from 'commons-general/models/TradeInVehicle/TradeInVehicleModel.js';
import Account from 'commons-general/models/Account/AccountModel.js';

import ApolloClient, { ReactApolloClient } from 'commons-general/clients/ApolloClient/ApolloClient.js';
import ReduxClient from 'commons-general/clients/ReduxClient/ReduxClient.js';

import en from 'commons-general/i18n/en.json';
import fr from 'commons-general/i18n/fr.json';

const Translations = { en, fr };

export {
    withModal,
    ClickOut,
    YoutubePlayer,
    LightBox,
    Modal,
    LoginModal,
    WhiteModal,
    NoSSR,
    LoaderFullScreen,
    TRACKING_TAGS,
    VIRTUAL_PAGEVIEWS,
    DATA_LAYER_VARIABLES,
    COOKIES,
    TIME,
    LEAD_TYPES,
    REDIRECTIONS,
    MEDIA_QUERIES,
    EVENTS,
    MODAL_NAMES,
    AnalyticsService,
    AccountService,
    CookieService,
    LeadService,
    ShiftDigitalService,
    LocalStorageService,
    ModalInstance,
    ModalService,
    ProfileService,
    UtilsService,
    StateService,
    HistoryService,
    SessionStorageService,
    accountReducer,
    accountActions,
    accountActionTypes,
    Lead,
    TradeInVehicle,
    Translations,
    Account,
    ApolloClient,
    ReduxClient,
    VehiclesService,
    RectangleSkeleton,
};

export default {
    withModal,
    ClickOut,
    YoutubePlayer,
    LightBox,
    Modal,
    LoginModal,
    WhiteModal,
    NoSSR,
    LoaderFullScreen,

    COOKIES,
    TIME,
    LEAD_TYPES,
    REDIRECTIONS,
    MEDIA_QUERIES,
    EVENTS,
    MODAL_NAMES,
    TRACKING_TAGS,
    VIRTUAL_PAGEVIEWS,
    DATA_LAYER_VARIABLES,

    AnalyticsService,
    CookieService,
    LeadService,
    ShiftDigitalService,
    LocalStorageService,
    ModalInstance,
    ModalService,
    ProfileService,
    UtilsService,
    StateService,
    HistoryService,
    SessionStorageService,
    Translations,
    VehiclesService,

    accountReducer,
    accountActions,
    accountActionTypes,

    Lead,
    TradeInVehicle,
    Account,

    ReactApolloClient,
    ApolloClient,
    ReduxClient,
    RectangleSkeleton,
};
